import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface IconListProps {
  items: string[]
  className?: string
  iconColor?: string
}

export function IconList({
  items,
  className,
  iconColor = 'text-primary',
}: IconListProps) {
  return (
    <ul className={cn('space-y-3', className)}>
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-3">
          <Check
            className={cn('w-5 h-5 mt-0.5 flex-shrink-0', iconColor)}
          />
          <span className="text-gray-700">{item}</span>
        </li>
      ))}
    </ul>
  )
}
